export default "__VITE_ASSET__B4uoWKP1__"